import request from '@/utils/request'

export function getBaseInfo(params) {
    return request({
        url: '/base/info',
        method: 'get',
        params,
    })
}

export function queryDictList(params) {
    return request({
        url: '/base/dict/list',
        method: 'post',
        data: params,
    })
}

export function login(params) {
    return request({
        url: '/user/login',
        method: 'post',
        data: params,
    })
}

export function saveMerchant(params) {
    return request({
        url: '/base/merchant/save',
        method: 'post',
        data: params,
    })
}

export function removeMerchant(params) {
    return request({
        url: '/base/merchant/remove',
        method: 'post',
        data: params,
    })
}

export function queryMerchantPage(params) {
    return request({
        url: '/base/merchant/page',
        method: 'post',
        data: params,
    })
}

export function queryMerchantList(params) {
    return request({
        url: '/base/merchant/list',
        method: 'post',
        data: params,
    })
}

export function saveStore(params) {
    return request({
        url: '/base/store/save',
        method: 'post',
        data: params,
    })
}

export function removeStore(params) {
    return request({
        url: '/base/store/remove',
        method: 'post',
        data: params,
    })
}

export function queryStore(params) {
    return request({
        url: '/base/store/page',
        method: 'post',
        data: params,
    })
}

export function queryStoreList(params) {
    return request({
        url: '/base/store/list',
        method: 'post',
        data: params,
    })
}

export function queryStoreByMerchant(params) {
    return request({
        url: '/base/store/list/merchant',
        method: 'post',
        data: params,
    })
}

export function saveUser(params) {
    return request({
        url: '/user/save',
        method: 'post',
        data: params,
    })
}


export function queryUserPage(params) {
    return request({
        url: '/user/query/page',
        method: 'post',
        data: params,
    })
}

export function removeUserInfo(params) {
    return request({
        url: '/user/remove',
        method: 'post',
        data: params,
    })
}

export function queryRolePage(params) {
    return request({
        url: '/base/role/page',
        method: 'post',
        data: params,
    })
}

export function queryRoleList(params) {
    return request({
        url: '/base/role/list',
        method: 'post',
        data: params,
    })
}

export function queryRoleAndGroup(params) {
    return request({
        url: '/base/rolegroup',
        method: 'post',
        data: params,
    })
}

export function saveRole(params) {
    return request({
        url: '/base/role/save',
        method: 'post',
        data: params,
    })
}

export function removeRole(params) {
    return request({
        url: '/base/role/remove',
        method: 'post',
        data: params,
    })
}

export function saveRoleMenu(params) {
    return request({
        url: '/base/role/menu/save',
        method: 'post',
        data: params,
    })
}

export function queryRoleMenuList(params) {
    return request({
        url: '/base/role/menu/list',
        method: 'post',
        data: params,
    })
}

export function queryUserAuthInfo(params) {
    return request({
        url: '/user/auth/info',
        method: 'post',
        data: params,
    })
}

export function saveUserAuth(params) {
    return request({
        url: '/user/auth/save',
        method: 'post',
        data: params,
    })
}

export function modifyMyPassword(params) {
    return request({
        url: '/user/modify/password',
        method: 'post',
        data: params,
    })
}

export function modifyMySelf(params) {
    return request({
        url: '/user/modify/self',
        method: 'post',
        data: params,
    })
}

export function saveMember(params) {
    return request({
        url: '/member/save',
        method: 'post',
        data: params,
    })
}

export function recharge(params) {
    return request({
        url: '/member/recharge',
        method: 'post',
        data: params,
    })
}

export function charge(params) {
    return request({
        url: '/member/charge',
        method: 'post',
        data: params,
    })
}

export function queryMemberPage(params) {
    return request({
        url: '/member/query/page',
        method: 'post',
        data: params,
    })
}

export function removeMember(params) {
    return request({
        url: '/member/remove',
        method: 'post',
        data: params,
    })
}

export function resetPassword(params) {
    return request({
        url: '/user/reset/pwd',
        method: 'post',
        data: params,
    })
}

export function saveUserGroup(params) {
    return request({
        url: '/base/save/group',
        method: 'post',
        data: params,
    })
}

export function queryUserGroupPage(params) {
    return request({
        url: '/base/query/group/page',
        method: 'post',
        data: params,
    })
}

export function queryUserGroupList(params) {
    return request({
        url: '/base/query/group/list',
        method: 'post',
        data: params,
    })
}

export function removeUserGroup(params) {
    return request({
        url: '/base/remove/group',
        method: 'post',
        data: params,
    })
}

export function queryUserWithGroup(params) {
    return request({
        url: '/user/query/group',
        method: 'post',
        data: params,
    })
}


export function querySupplierPage(params) {
    return request({
        url: '/bd/page/supplier',
        method: 'post',
        data: params,
    })
}


export function removeSupplierInfo(params) {
    return request({
        url: '/bd/remove/supplier',
        method: 'post',
        data: params,
    })
}


export function saveSupplierInfo(params) {
    return request({
        url: '/bd/save/supplier',
        method: 'post',
        data: params,
    })
}

export function querySupplierList(params) {
    return request({
        url: '/bd/list/supplier',
        method: 'post',
        data: params,
    })
}
